import React, { useState, useEffect } from 'react';
import { ADMISSION_CONFIG } from '../../constants/admissionConfig';

interface AdmissionDateProps {
    type?: 'academicYear' | 'academicYearShort' | 'deadline' | 'remainingDays';
    className?: string;
    asFragment?: boolean;
}

const AdmissionDate: React.FC<AdmissionDateProps> = ({
    type = 'academicYear',
    className = '',
    asFragment = false
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null; // Don't render on server to avoid hydration mismatch
    }

    let content = '';

    switch (type) {
        case 'academicYearShort':
            content = ADMISSION_CONFIG.academicYearShort;
            break;
        case 'deadline':
            content = ADMISSION_CONFIG.deadlineStr;
            break;
        case 'remainingDays':
            const deadline = new Date(ADMISSION_CONFIG.deadlineFull).getTime();
            const now = new Date().getTime();
            const diff = deadline - now;
            const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
            content = days > 0 ? `${days} Days Left` : 'Admission Closed';
            break;
        case 'academicYear':
        default:
            content = ADMISSION_CONFIG.academicYear;
            break;
    }

    if (asFragment) {
        return <>{content}</>;
    }

    return <span className={className}>{content}</span>;
};

export default AdmissionDate;

